import { FunctionComponent, ReactNode } from 'react'
import RadarTour from '@/components/tour'
import GlobalOnboardingTourModal from '@/components/tour/global-onboarding-tour-modal'
import VerifyEmailTour from '@/components/tour/verify-email'

interface BaseLayoutProps {
  children: ReactNode
}

const TourLayout: FunctionComponent<BaseLayoutProps> = ({ children }) => {
  return (
    <>
      {children}
      <GlobalOnboardingTourModal />
      <RadarTour />
      <VerifyEmailTour />
    </>
  )
}

export default TourLayout
